import React, { useState, useEffect } from 'react';

import useAuth from 'src/hooks/useAuth';

import ElementLabel from './ElementLabel';
import useLocales from '../../../hooks/useLocales';
import { useSelector } from '../../../redux/store';
import { ElementProps } from '../../../@types/forms/types';
import { UserDataType } from '../../../@types/forms/enums/UserDataType';

type UserDataElementProps = {
  el: ElementProps;
  pageNumberScale: number;
  isFormFillerPage: boolean;
};

const UserDataElement: React.FC<UserDataElementProps> = ({
  el,
  pageNumberScale,
  isFormFillerPage,
}) => {
  const { t } = useLocales();
  const [label, setLabel] = useState<string>('');
  const { profile } = useSelector((state) => state.profile);
  const { user } = useAuth();

  const setProfileOptionLabel = () => {
    const option = el.userDataOption;

    switch (option) {
      case UserDataType.Name:
        setLabel(`${profile?.firstName} ${profile?.lastName}`);
        break;

      case UserDataType.Email:
        setLabel(`${user?.email || profile?.email || ''}`);
        break;

      case UserDataType.Phone:
        setLabel(`${profile?.phoneNumber}`);
        break;

      case UserDataType.Company:
        setLabel(`${profile?.companyName}`);
        break;

      case UserDataType.Job:
        setLabel(`${profile?.jobTitles.map((job) => job.name).join(', ')}`);
        break;

      case UserDataType.Address:
        setLabel(`${profile?.address}, ${profile?.city}, ${profile?.zipCode} ${profile?.country}`);
        break;

      case UserDataType.ManagersName:
        setLabel(
          `${profile?.userDoclogixManager.firstName} ${profile?.userDoclogixManager.lastName}`
        );
        break;

      case UserDataType.ManagersEmail:
        setLabel(`${profile?.userDoclogixManager.email}`);
        break;

      default:
        setLabel(' ');
    }
  };

  const setOptionLabel = () => {
    const option = el.userDataOption;

    switch (option) {
      case UserDataType.Name:
        setLabel(`${t('forms.elements.settings.nameSurname')}`);
        break;

      case UserDataType.Email:
        setLabel(`${t('forms.elements.settings.emailAddress')}`);
        break;

      case UserDataType.Phone:
        setLabel(`${t('forms.elements.settings.phoneNumber')}`);
        break;

      case UserDataType.Company:
        setLabel(`${t('forms.elements.settings.company')}`);
        break;

      case UserDataType.Job:
        setLabel(`${t('forms.elements.settings.jobTitle')}`);
        break;

      case UserDataType.Address:
        setLabel(`${t('forms.elements.settings.address')}`);
        break;

      case UserDataType.ManagersName:
        setLabel(`${t('forms.elements.settings.managersName')}`);
        break;

      case UserDataType.ManagersEmail:
        setLabel(`${t('forms.elements.settings.managersEmail')}`);
        break;

      default:
        setLabel(`${t('forms.elements.settings.notSelected')}`);
    }
  };

  useEffect(() => {
    if (!isFormFillerPage) {
      setOptionLabel();
    }
  }, [el.userDataOption]);

  useEffect(() => {
    if (isFormFillerPage) {
      setProfileOptionLabel();
    }
  }, [profile]);

  return <ElementLabel el={el} label={label} pageNumberScale={pageNumberScale} isStatic />;
};

export default UserDataElement;
